import { useCallback } from 'react';
import _ from 'lodash';
import { singleFieldRow } from '../../ReferralFormFields/utils/selectField';

function shouldClearFeeSchedule(feeScheduleProgramId, selectedFields, index) {
  return (
    !_.isNull(feeScheduleProgramId) &&
    selectedFields.length >= 2 &&
    index === 0 &&
    _.isEmpty(selectedFields[1].program.value)
  );
}

function deselectSingleField(selectedFields, index, feeScheduleProgramId, setFeeScheduleProgramId) {
  selectedFields[index].program.onChange('');
  selectedFields[index].group.onChange('');
  if (!_.isNull(feeScheduleProgramId)) {
    setFeeScheduleProgramId(null);
  }
}

function deselectMultiField(selectedFields, index, feeScheduleProgramId, setFeeScheduleProgramId) {
  if (shouldClearFeeSchedule(feeScheduleProgramId, selectedFields, index)) {
    setFeeScheduleProgramId(null);
  }
  selectedFields.removeField(index);
}

function deselectField(selectedFields, index, feeScheduleProgramId, setFeeScheduleProgramId) {
  if (singleFieldRow(selectedFields.length)) {
    deselectSingleField(selectedFields, index, feeScheduleProgramId, setFeeScheduleProgramId);
  } else {
    deselectMultiField(selectedFields, index, feeScheduleProgramId, setFeeScheduleProgramId);
  }
}

function refreshBrowseGroups(canPaginateNetworkGroups, removeSelectedBrowseGroup) {
  if (canPaginateNetworkGroups) {
    removeSelectedBrowseGroup('in-network');
  }
}

export default function useDeselectHandler({
  canPaginateNetworkGroups,
  feeScheduleProgramId,
  removeSelectedBrowseGroup,
  selectedFields,
  setFeeScheduleProgramId,
}) {
  const onSelect = useCallback(() => {
    refreshBrowseGroups(canPaginateNetworkGroups, removeSelectedBrowseGroup);
  }, [canPaginateNetworkGroups, removeSelectedBrowseGroup]);

  const onDeselect = useCallback((index) => {
    refreshBrowseGroups(canPaginateNetworkGroups, removeSelectedBrowseGroup);
    deselectField(selectedFields, index, feeScheduleProgramId, setFeeScheduleProgramId);
  }, [canPaginateNetworkGroups, feeScheduleProgramId, removeSelectedBrowseGroup,
    selectedFields, setFeeScheduleProgramId]);

  return { onSelect, onDeselect };
}
